import { apiClient } from "@/lib/api-client";
import { GetTimeSlots } from "../dto/timeslotDto";

export const GetTimeSlotsById = async (token: string): Promise<GetTimeSlots> => {
    const response = await apiClient.get(`/interview/scheduling/${token}`);
    return response.data;
};

export const BookTimeSlot = async (token: string, selectedTimeSlotId: string, captchaToken: string = ""): Promise<boolean> => {
    const response = await apiClient.post(`/interview/scheduling/${token}`, {
        selectedTimeSlotId,
        captchaToken,
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};
